import request from "../libs/request";

import { BuildingId } from "../types/building";

import {
  VoteIdRequest,
  VoteItem,
  VotePeriod,
  VoteSpace,
  VoteStatus,
  VoteSummary,
} from "./hotColdVoteServices";
import { SatisfactionInfo } from "./spaceReservationServices";

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/manager/hot-cold/vote`;

export type ManagerHotColdVoteFeedbackRequest = VoteIdRequest & {
  feedback: string;
};

export const postManagerHotColdVoteFeedback = (
  params: ManagerHotColdVoteFeedbackRequest
) =>
  request.post(`${baseUrl}/${params.voteId}/feedback`, {
    feedback: params.feedback,
  });

export const patchManagerHotColdVoteFeedback = (
  params: ManagerHotColdVoteFeedbackRequest
) =>
  request.patch(`${baseUrl}/${params.voteId}/feedback`, {
    feedback: params.feedback,
  });

export type VoteSatisfactionInfo = Omit<SatisfactionInfo, "reply"> & {
  voteItemId: number;
  createdByNickName?: string;
  createdByEmail?: string;
  reply?: VoteSatisfactionInfo;
};

export type GetManagerHotColdVoteSatisfactionResponse = {
  average: number;
  satisfaction: VoteSatisfactionInfo[];
};

export const getManagerHotColdVoteSatisfaction = (params: VoteIdRequest) =>
  request.get<GetManagerHotColdVoteSatisfactionResponse>(
    `${baseUrl}/${params.voteId}/satisfaction`
  );

export type GetManagerHotColdVoteBuildingSpaceRequest = {
  voteDate?: string;
  votePeriod?: VotePeriod;
};

export const getManagerHotColdVoteBuildingSpace = (
  buildingSpaceId: string,
  params: GetManagerHotColdVoteBuildingSpaceRequest
) =>
  request.get<VoteSpace>(`${baseUrl}/building-space/${buildingSpaceId}`, {
    params,
  });

export type ManagerVote = BuildingId & {
  voteId: number;
  buildingName: string;
  buildingFloorId: string;
  buildingFloorName: string;
  buildingSpaceId: string;
  buildingSpaceName: string;
  location: string;
  status: VoteStatus;
  serviceTemplateId: string;
  centerIncommodityId: string;
  voteDate: string;
  votePeriod: VotePeriod;
  result: string;
  createdBy: number;
  createdAt: string;
  createdByNickname: string;
  creatorVoteItem: VoteItem | null;
  modifiedBy: number;
  modifiedAt: string;
  startedAt: string;
  endedAt: string;
  feedback: string;
  feedbackAt: string;
  summary: VoteSummary;
  isSatisfactionRegistered: boolean;
  locale: string;
};

export const getManagerHotColdVote = (params: VoteIdRequest) =>
  request.get<ManagerVote>(`${baseUrl}/${params.voteId}`);
